import React from "react";

import TarjetaFacturadoVendedor from "./cards/TarjetaFacturadoVendedor";
import TarjetaIngresosVendedor from "./cards/TarjetaIngresosVendedor";
import TarjetaCxCVendedor from "./cards/TarjetaCxCVendedor";
import TarjetaOrdenesCompraVendedor from "./cards/TarjetaOrdenesCompraVendedor";
import TarjetaCotizacionesVendedor from "./cards/TarjetaCotizacionesVendedor";
import TarjetaNotasCreditoVendedor from "./cards/TarjetaNotasCreditoVendedor";

const AppCardVendedor = ({
    desde,
    hasta,
}) => {
    const styles = {
        cardsContainer: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            width: '100%',
            padding: 0,
            margin: "0 0 15px",
            rowGap: "10px",
            columnGap: "10px",
        },
        paragraph: {
			fontSize: "16px",
			marginBottom: "7px",
			textTransform: "upperCase",
			textAlign: "center",
		},
        columnStyles: {
			borderRadius: "8px",
			padding: "7px",
			margin: "3px",
			minHeight: "100px",
			background: "white",
            flex: 1,
		},
        columnContainer: {
            padding: "10px",
            lineHeight: 1,
            position: "relative",
        },
        header: {
            borderBottom: "1px solid #ddd",
            paddingBottom: "2px",
            marginBottom: "2px",
        },
        principal: {
            fontSize: "24px",
            fontWeight: "bold",
        },
        subtitulo: {
            margin: "4px 0",
            textTransform: "uppercase",
            fontWeight: "500",
            fontSize: "13px",
            color: "#999"
        },
        infoBlockContainer: {
            maxHeight: "75px",
            overflow: "hidden",
        },
        infoBlock: {
            marginTop: "7px",
            padding: "0 15px",
            width: "100%",
        },
        label: {
            fontSize: "10px",
            textTransform: "uppercase",
            color: "#999",
            marginTop: "3px",
            display: "block"
        },
        hr: {
            margin: "5px 0"
        },
        expandir: {
            textAlign: 'center',
            textTransform: 'uppercase',
            width: "100%",
            fontSize: "11px",
            position: "absolute",
            bottom: 0,
            left: 0,
            color: "#999",
            padding: "55px 7px 10px",
            background: "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))"
        }
    }

	return (
        <>
            <style>
				{`
                    @import url('https://fonts.googleapis.com/css2?family=Saira+Extra+Condensed:wght@400;700&display=swap');
                    .loader-wrapper {
                        padding: 15px !important;
                        height: 140px;
                    }
                    @media(max-width: 800px) {
                        .dashboard-cards-container {
                            grid-template-columns: 1fr !important;
                        }
                    }
				`}
			</style>
            <div className="dashboard-cards-container" style={styles.cardsContainer}>
                {/*Facturado del mes */}
                <TarjetaFacturadoVendedor desde={desde} hasta={hasta} styles={styles} />

                {/* Card Ingresos */}
                <TarjetaIngresosVendedor desde={desde} hasta={hasta} styles={styles} />

                {/* CXC */}
                <TarjetaCxCVendedor desde={desde} hasta={hasta} styles={styles}/>

                {/* Ordenes de Compra */}
                <TarjetaOrdenesCompraVendedor desde={desde} hasta={hasta} styles={styles} />

                {/* Cotizaciones */}
                <TarjetaCotizacionesVendedor desde={desde} hasta={hasta} styles={styles} />

                {/* Notas de Crédito */}
                <TarjetaNotasCreditoVendedor desde={desde} hasta={hasta} styles={styles} />
            </div>
        </>
	);
};

export default AppCardVendedor;
